import { render, staticRenderFns } from "./CHPPLogin.vue?vue&type=template&id=ab4c5e48&scoped=true&"
import script from "./CHPPLogin.vue?vue&type=script&lang=ts&"
export * from "./CHPPLogin.vue?vue&type=script&lang=ts&"
import style0 from "./CHPPLogin.vue?vue&type=style&index=0&id=ab4c5e48&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab4c5e48",
  null
  
)

export default component.exports